import { Injectable, inject } from '@angular/core';
import { UserService } from './user.service';
import { SUPRSEND_CONFIG } from '@/shared/constants/suprsend.config';
import { initSuprSend, clearSuprSend } from "@suprsend/web-components";
import { SuprSend, Feed } from '@suprsend/web-sdk';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SuprsendService {
    private userService = inject(UserService);
    private suprSendInstance: SuprSend | null = null;
    private isInitialized = new BehaviorSubject<boolean>(false);
    public isInitialized$ = this.isInitialized.asObservable();

    constructor() {
        this.initializeOnUserLoad();
    }

    private initializeOnUserLoad() {
        this.userService.getProfileTypeInfo().subscribe((profile) => {
            if (profile && profile.mail) {
                this.init(profile.mail);
            }
        });
    }

    private init(distinctId: string) {
        // Si ya está inicializado con el mismo ID, no hacer nada
        if (this.suprSendInstance && this.isInitialized.value) {
            // En algunos casos podrías querer re-inicializar si el ID cambia
            return;
        }

        const config = {
            ...SUPRSEND_CONFIG,
            distinctId: distinctId
        };

        // Inicializar Recursos Web (Inbox/Toast)
        initSuprSend(config);

        // Inicializar SDK para otras funcionalidades (WebPush, etc)
        this.suprSendInstance = new SuprSend(config.publicApiKey);
        this.suprSendInstance.identify(distinctId);

        console.log('SuprSend dinámicamente inicializado para:', distinctId);

        this.suprSendInstance.webpush.registerPush();
        this.isInitialized.next(true);
    }

    public getFeedInstance(): Feed | null {
        if (!this.suprSendInstance) return null;
        return this.suprSendInstance.feeds.initialize();
    }

    public logout() {
        clearSuprSend();
        this.suprSendInstance = null;
        this.isInitialized.next(false);
    }
}
